import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { IAMBankHashRequest, IPayUHashResponse } from './models';

const TAG = ApiTags.Payment;

const amBankApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getAMHash: builder.mutation<IPayUHashResponse, IAMBankHashRequest>({
      query: (model) => ({
        url: '/Payments/AMBank',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    })

  })
})

export const {
  useGetAMHashMutation,
} = amBankApi;